export class CacheRules {
  public bypassCookie: string[];
  public bypassPageUrlRegex: string[];
  public includeQueryString: string[];
  public disablePageCache: boolean;
  public disableCdn: boolean;

  constructor(data) {
    this.bypassCookie = data.BYPASS_COOKIE;
    this.bypassPageUrlRegex = data.BYPASS_PAGE_URL_REGEX;
    this.includeQueryString = data.INCLUDE_QUERY_STRING;
    this.disablePageCache = !!data.DISABLE_PAGE_CACHE;  // default 1
    this.disableCdn = !!data.DISABLE_CDN;  // default 0
  }
}
